import { classNames } from "@ct-react/core";
import SpriteSvg from "./svg";

import "./icones.scss";

type Props = {
  className?: string
}

const Instagram = ({className}:Props) => {
  return(
    <a href="https://www.instagram.com/verbierrentals/" className={classNames("icone",className)} aria-label="Find us on Instagram" target="_blank"><SpriteSvg id="instagram"/></a>
  );
};

const Facebook = ({className}:Props) => {
  return(
  <a href="https://www.facebook.com/verbierrentals/"  className={classNames("icone",className)} aria-label="Find us on Facebook" target="_blank"><SpriteSvg id="facebook"/></a>
  );
};

const WhatsApp = ({className}:Props) => {
  return(
    <a href="https://wa.me/+41794876948" className={classNames("icone",className)} aria-label="Contact us by Whatsapp" target="_blank"><SpriteSvg id="whatsapp"/></a>
  );
};

export {
  Instagram,
  Facebook,
  WhatsApp
};
